document.addEventListener("DOMContentLoaded", function () {
    const sliders = document.querySelectorAll("m-slideshow");

    if (!sliders.length) return;

    sliders.forEach((sliderEl) => {
        const id = sliderEl.dataset.id;
        const autoplayEnabled = sliderEl.dataset.autoplay === "true";
        const autoplaySpeed = parseInt(sliderEl.dataset.autoplaySpeed) * 1000 || 5000;

        const enableArrows = sliderEl.dataset.enableArrows === "true";
        const enableDots = sliderEl.dataset.enableDots === "true";

        const container = sliderEl.querySelector(".swiper-container");

        if (!container) return;

        const swiper = new Swiper(container, {
            loop: true,
            speed: 600,

            autoplay: autoplayEnabled
                ? {
                      delay: autoplaySpeed,
                      disableOnInteraction: false,
                  }
                : false,

            pagination: enableDots
                ? {
                      el: sliderEl.querySelector(".swiper-pagination"),
                      clickable: true,
                  }
                : false,

            navigation: enableArrows
                ? {
                      nextEl: sliderEl.querySelector(".swiper-button-next"),
                      prevEl: sliderEl.querySelector(".swiper-button-prev"),
                  }
                : {},

            slidesPerView: 1,
        });

        // Fix clickable images
        const slideLinks = sliderEl.querySelectorAll(".swiper-slide a");
        slideLinks.forEach((link) => {
            link.style.pointerEvents = "auto"; // ensure image links receive clicks
            link.addEventListener("click", (e) => {
                // Stop Swiper from blocking the click
                e.stopPropagation();
            });
        });
    });
});
